import { appUrl } from '~/config/settings/app.settings';
import { kazooPulseAuthEndpoint } from '~/config/settings/worktango.settings';

// example: http://localhost:3000/surveys/build/7794/configure
const SURVEY_BUILD_URL = '/surveys/build';
// example: http://localhost:3000/surveys/debug?surveys=1936,1788
const REPORTING_URLS = [
  '/surveys/overview',
  '/surveys/response-rate',
  '/surveys/results',
  '/surveys/analyze',
  'surveys/heatmap',
  '/surveys/debug',
];

function extractSurveyId(redirectToUrl: string | null) {
  if (!redirectToUrl) return null;

  const isBuildUrl = redirectToUrl.startsWith(SURVEY_BUILD_URL);
  if (isBuildUrl) {
    const surveyIdMatch = redirectToUrl.match(/\/surveys\/build\/(\d+)/);
    return surveyIdMatch ? surveyIdMatch[1] : null;
  }

  const isReportingUrl = REPORTING_URLS.some((surveyUrl) => redirectToUrl.startsWith(surveyUrl));
  if (isReportingUrl) {
    // The surveys param can contain several surveys, but we are just interested in the first one
    const surveyIdMatch = redirectToUrl.match(/surveys=([\d]+)/);
    return surveyIdMatch ? surveyIdMatch[1] : null;
  }

  return null;
}

function makeKazooUrlWithRedirect({ kazooBaseUrl, redirectUrl }: { kazooBaseUrl: string; redirectUrl: string }) {
  const pulseUrlObject = new URL(appUrl);
  pulseUrlObject.pathname = redirectUrl;

  const kazooUrlObject = new URL(kazooBaseUrl);
  kazooUrlObject.searchParams.append('redirectTo', pulseUrlObject.href);
  kazooUrlObject.pathname = kazooPulseAuthEndpoint;

  return kazooUrlObject.href;
}

export { extractSurveyId, makeKazooUrlWithRedirect };
